module.exports = __webpack_public_path__ + "static/media/Accept.e26ffaa2.png";